<template>
	<div>
		<hr/>
		
		<h2>Contratos y Pre-Contratos</h2>
		<br>
		<input type="text" id='busca' align="center" v-model='abuscar'  size="20" placeholder="Buscar"autofocus > 
		<br>
		<br>
    <br>

		<ul id='contratos-lista' v-if="contratosTodos !=null" align="left">
			<li v-for="contra in buscando" >	

				<div v-on:click="lanza(contra.id, contra.inquilinoId, contra.propiedadId, contra.inquilino, contra.propiedad, contra.giro, contra.familia, contra.subfamilia, contra.dueno, contra.emailInquilino, contra.importeMes, contra.claveCat)" v-if="esRentado(contra.status)">
					<strong>
						
					    Contrato Num.  {{contra.id}} <br>
						  Inquilino: {{contra.inquilino}} <br><br>
						  Propiedad: {{contra.propiedad}}<br><br>
						  Giro: <font color="purple">{{contra.giro}}<br>
					    {{contra.nombreComercial}} </font><br><br>
                        Renta mensual: {{contra.importeMes}} <br>
					    {{contra.familia}} <br>
					    {{contra.subfamilia}}  <br>
                        {{contra.claveCat}}  <br>
                        <br><br>

              <font color="red" v-if="contra.status =='PRE-CONTRATO' ">{{contra.status}}</font> <br>

              <font color="black" v-if="contra.status !='PRE-CONTRATO' ">{{contra.status}}</font> <br>

					</strong>
				<br>
				<button type='button' v-on:click="lanza(contra.id, contra.inquilinoId, contra.propiedadId, contra.inquilino, contra.propiedad, contra.giro, contra.familia, contra.subfamilia, contra.dueno, contra.emailInquilino, contra.importeMes, contra.claveCat)" class="button is-primary is-rounded"> Seleccionar
				</button>
        </div>

  		</li>
		</ul>
		<span v-else>Cargando contratos ...</span>
	</div>
</template>


<script>
import axios from 'axios';

export default {
  name: 'ContratosYpre-buscar',
  mounted(){
  	this.getContratos();
  },
  data () {
    return {
      contratosTodos: null,
      abuscar:''
    }
  },
  methods:{	
    	lanza: function(idCon, inId, prId, inq, pr, gir, fam, subfam, dueno, elmail, renta, claveCa){
  	    	  this.$emit('eventoConYpre',idCon, inId, prId, inq, pr, gir, fam, subfam, dueno, elmail, renta, claveCa );
    	},
    	getContratos(){
    		axios.get('https://www.directodo.com/Rentus/accesosdb/leeContratos.php')
    		     .then((respuesta) => {
    		     	this.contratosTodos = respuesta.data;
    			 });
    	},
      esRentado(status){
        if (status == 'RENTADO' || status == 'PRE-CONTRATO') {
          return true;
        }
        else return false;
      }

  },
  computed:{
  	buscando: function () {
  		return this.contratosTodos.filter((item) => 
  				   item.giro.toUpperCase().includes(this.abuscar.toUpperCase()) 
  				|| item.inquilino.toUpperCase().includes(this.abuscar.toUpperCase()) 
          || item.id.toUpperCase().includes(this.abuscar.toUpperCase()) 
  				|| item.propiedad.toUpperCase().includes(this.abuscar.toUpperCase()) 
  				|| item.familia.toUpperCase().includes(this.abuscar.toUpperCase()) 
  				|| item.subfamilia.toUpperCase().includes(this.abuscar.toUpperCase()) 
  				|| item.nombreComercial.toUpperCase().includes(this.abuscar.toUpperCase()) );

  	}
  }
}

</script>

<style lang="scss">

</style>




// WEBPACK FOOTER //
// src/ContratosY-pre-contratos-buscar.vue